import {Component, Inject, Input} from '@angular/core';
import {PopupService} from '../../popup/popup.service';
import {FeedbackPopupService} from '../feedback-popup.service';
import {FEEDBACK_RESOURCE_TOKEN, FeedbackService} from '../../../services/FeedbackService';

@Component({
    selector: 'mm-feedback-result-popup',
    templateUrl: './feedback-result-popup.component.html',
    styleUrls: ['./feedback-result-popup.component.scss'],
    standalone: false
})
export class FeedbackResultPopupComponent {
    @Input()
    public startNewFeedback: boolean = false;

    constructor(public popupService: PopupService,
                public feedbackPopupService: FeedbackPopupService,
                @Inject(FEEDBACK_RESOURCE_TOKEN) private feedbackResource: FeedbackService) {
    }

    public closePopup(): void {
        this.feedbackResource.closeFeedback();
    }

}
